module.exports = __webpack_public_path__ + "static/media/ga.d41ba93e.svg";